import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  filteredAccounts: [],
  filteredRecipients: [],
};

const dailyConfirmsSlice = createSlice({
  name: 'dailyconfirms',
  initialState,
  reducers: {
    storeFilteredRecipients: (state, { payload }) => {
      state.filteredRecipients = payload;
    },
    storeFilteredAccounts: (state, { payload }) => {
      state.filteredAccounts = payload;
    },
  },
});

export const { storeFilteredRecipients, storeFilteredAccounts } =
  dailyConfirmsSlice.actions;
export default dailyConfirmsSlice.reducer;
